// Analytics layout providing sub-navigation for all analytics routes
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AnalyticsNav } from '@/features/analytics/components';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/analytics')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.analytics'),
  }),
  component: AnalyticsLayout,
});

/**
 * Analytics layout wrapping all analytics pages.
 * Provides consistent sub-navigation for analytics pages.
 */
function AnalyticsLayout() {
  return (
    <div className="min-h-screen bg-background">
      <AnalyticsNav />
      <Outlet />
    </div>
  );
}
